export default "__VITE_ASSET__bca5b9f0__"